export let loadMorePostsSetup = () => {
  if( document.querySelector( '.js-posts-wrapper' ) ) {
    //set all initial variables
    let postContainer = document.querySelector( '.js-posts-wrapper' ),
      loadMore_btn    = document.querySelector( '.js-load-more-btn' ),
      totalPages      = document.querySelector( '.js-load-more-btn' ).getAttribute('data-totalpages'),
      currentPage     = 1,
      url             = document.location.href,
      fetchUrl        = url.match(/[?]/) ? url + '&paged=' : url + '?paged=', //checking permalink structure
      parser          = new DOMParser(); //Initialize the DOM parser

    if (currentPage == totalPages) {

      //run if there is only 1 page
      loadMore_btn.classList.add( 'end-page' )
      loadMore_btn.disabled = true
      loadMore_btn.innerHTML = 'No more posts'

    } else if ( currentPage < totalPages ) {

      //run if there is more than 1 page
      loadMore_btn.disabled = false

      //add event listener for the load more button
      loadMore_btn.addEventListener( 'click', loadMorePosts )

    }


    /**
     * @callback loadMorePosts
     * async function for the fetch function with await
     */
    async function loadMorePosts() {

      //increment page number for each click
      currentPage++

      //change button text while loading
      this.innerHTML = 'Loading...'

      //fetch function and returned data
      let data = await( await fetch( fetchUrl + currentPage ).catch( errorHandle ) ).text(),

        //use DOMParser to convert text string to HTML nodes
        htmlData = parser.parseFromString( data, 'text/html' ),

        //select posts that will be appended
        posts = htmlData.querySelectorAll( '.js-post-card' )

      for( let i = 0; i < posts.length; i++ ) {

        //initially add 'hide' class to the posts for fadein effect
        posts[i].classList.add( 'hide' )

        //then append it to the container
        postContainer.append( posts[i] )
      }

      /*********** fadein effect ***********/
        //select all hidden posts
      let hiddenPosts = postContainer.querySelectorAll( '.hide' ),

        //set time out and make the posts visible
        //css transition will fade in
        timer = setTimeout( function() {
          Array.prototype.map.call( hiddenPosts, function (el ) {
            el.classList.remove( 'hide' )
            el.classList.add( 'show' )
          })
        }, 300 )
      /*********** fadein effect ends ***********/

      if( currentPage == totalPages ) {

        //if there is no more page,
        //disable the button
        this.classList.add('end-page')
        this.disabled = true
        this.innerHTML = 'No more posts'

      } else {

        //if there is more pages,
        //change the button text
        this.innerHTML = 'Load More'
      }

    }


    /**
     * @callback errorHandle
     * @param err to handle errors
     */
    function errorHandle( err ) {
      console.warn( err )
    }
  }
};
